import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { takeUntil } from 'rxjs';
import { BaseComponentDirective } from '../base-component';
import { ApiService } from '../shared/services/api/api.service';

@Component({
  selector: 'gk-home',
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss'
})
export class HomeComponent extends BaseComponentDirective implements OnInit {
  menuOpen = false;
  isLoading = false;
  isLoadingShowOverlay = false;

  constructor(
    private router: Router,
    private apiService: ApiService
  ) {
    super();
  }

  ngOnInit() {
    if (this.router.url === '/') {
      this.router.navigate(['/dashboard']);
    }

    this.apiService.isLoading
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(result => {
        if (result != null) {
          this.isLoading = result.isLoading;
          this.isLoadingShowOverlay = result.showOverlay;
        }
      });
  }
}
